export var BoilerControlType;
(function (BoilerControlType) {
    BoilerControlType["OFF"] = "OFF";
    BoilerControlType["RELAY"] = "RELAY";
    BoilerControlType["DIGITAL"] = "DIGITAL";
    BoilerControlType["UNKNOWN"] = "UNKNOWN";
})(BoilerControlType || (BoilerControlType = {}));
export var HeatingControlType;
(function (HeatingControlType) {
    HeatingControlType["OFF"] = "OFF";
    HeatingControlType["DIRECT"] = "DIRECT";
    HeatingControlType["MIX"] = "MIX";
})(HeatingControlType || (HeatingControlType = {}));
